import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
import '../css/about.css';

export default class About extends Component {
  componentDidMount() {
    window.scrollTo(0,0)
  }
  render() {
    return(
      <div className="container-fluid blogs">
       <div className="row">
       <MetaTags>
            <title>草學藥事 || 關於我們</title>
            <meta id="og-title" property="og:title" content="關於我們" />
        </MetaTags>
        <article className="AboutBanner"></article>
         <div className="container">
          <div className="row">
          <section className="AboutBox">
           <article>
            <h1 style={Jeyu.Color}>品牌緣起</h1>
            <p>
            平台創始人(Jay / Sherry 以下簡稱JS ).為全端開發工程師與UI/UX視覺規劃設計師....
            </p>
            <p>
            兩人都是超級重度電腦使用者，每天除了腦力耗盡外...長期坐著，以及外食，造成了身體大大的負擔。
            不但常常工作到頭暈目眩天旋地轉，就算三餐吃很少，體力和身材也大大的退步許多
            </p>
            <p>JS 發現這是一個很大的問題，在生活中我們開始去尋找對自己身體好的答案</p>
            <p>
            在尋求答案的過程中，我們發現飲食是一個很大的關鍵因素<br />
            大家都知道，外面的食物為了節省成本，或多或少會添加一些廉價(或對身體不好)的合成物來混合
            而這些添加物長期累積後，很容易就變成身體的致命毒素!
            </p>
            <p>
            我們在平時拜訪各大醫師與營養師後，把相關的知識與答案，整理成表格寫入資料庫<br />
            利用我們的專長，把這些數據變成平台，並且系統視覺化<br />
            目的在於讓使用者測驗完後，除了知道您身體的狀況外系統還能根據資料比對，
            給您一些對您有用的資訊，來幫助您真的做到健康管理的目的!
            </p>
            <p>
            為了增加測驗的趣味性，我們創造了品牌代表人物 "彩豆人"，以插畫的方式來重新詮釋表單的趣味。<br />
            為了大家的健康，我們願意把生活中蒐集而來的資訊，無條件的在這平台分享
            我們也期許自己不斷地去優化平台與資訊，未來將會開放更多有用的功能，請拭目以待!!
            </p>
           </article>
           <article style={Jeyu.hasPad}>
           <h1 style={Jeyu.Color}>關於彩豆人</h1>
            <ul className="listnone">
             <li>彩豆人</li>
             <li>平均年齡: 25歲 ~ 35歲</li>
             <li>職業: 每天用電腦8小時以上的上班族</li>
             <li>喜好:  1.喜歡下班後躺在床上追劇追到凌晨1~2點  2.下午每天一杯手搖飲料  3.周末補眠補到自然醒</li>
             <li>使用產品動機: 即將要初老階段，身體慢慢出現一些疾病，感覺身體一年不如一年</li>
             <li>需求: 彩豆人開始學習健康知識，從中理解到健康的本質與其他附加效益，固定每周運動2~3天，並改掉很多不好的習慣</li>
            </ul>
           </article>
          </section>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  hasPad: {
    padding: '20px 0px 0px'
  },
  Color: {
    color: '#325aaa'
  }
}



// WEBPACK FOOTER //
// ./src/View/About.js